import React from 'react';
import { TextInput } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';

import useGetUser from 'hooks/useGetUser';

const EmailInput: React.FC = () => {
    const user = useGetUser();

    const intl = useIntl();

    return (
        <TextInput
            id="settings-user-email"
            label={intl.formatMessage(messages.labelText)}
            type="email"
            value={user?.email ?? ''}
            disabled
            size="md"
        />
    );
};

const messages = defineMessages({
    labelText: {
        id: 'src.Screens.Dashboard.Settings.SettingsTabs.Email',
        defaultMessage: 'Email',
    },
});

export default EmailInput;
